import React from 'react';
import { CheckCircle, List, Users, Target } from 'lucide-react';
import { Link } from 'react-router-dom'; // ✅ make sure Link is imported

const HowItWorks = () => {
  const steps = [
    {
      icon: CheckCircle,
      title: 'Choose Your Exam & Preferences',
      description: 'Select your entrance exam, preferred courses, and location preferences to get started.',
      color: 'text-primary'
    },
    {
      icon: List,
      title: 'Get Your Personalized College List',
      description: 'Our smart algorithm generates a personalized list of colleges based on your profile.',
      color: 'text-success'
    },
    {
      icon: Users,
      title: 'Connect with Real Students',
      description: 'Chat with current students and alumni to get insider insights about your dream colleges.',
      color: 'text-info'
    }
  ];

  return (
    <section className="py-3 py-md-5 bg-white">
      <div className="container">
        <div className="text-center mb-4 mb-md-5 px-2">
          <h2 className="h1 fw-bold text-dark mb-3" style={{ fontSize: 'clamp(1.75rem, 5vw, 2.5rem)' }}>
            How It Works
          </h2>
          <p className="lead text-muted mx-auto" style={{ maxWidth: '600px', fontSize: 'clamp(1rem, 3vw, 1.25rem)' }}>
            Get personalized college recommendations in three simple steps
          </p>
        </div>

        <div className="row g-3 g-lg-5 align-items-center px-2 px-md-0">
          {steps.map((step, index) => {
            const Icon = step.icon;
            return (
              <div key={index} className="col-12 col-md-6 col-lg-4">
                <div className="text-center text-lg-start">
                  <div className="d-flex align-items-center justify-content-center justify-content-lg-start mb-3 mb-md-4">
                    <div className="position-relative">
                      <div className="step-number bg-primary text-white me-3" style={{ width: 'clamp(2rem, 5vw, 3rem)', height: 'clamp(2rem, 5vw, 3rem)', fontSize: 'clamp(0.8rem, 2.5vw, 1rem)' }}>
                        {index + 1}
                      </div>
                      <div className="feature-icon bg-light" style={{ width: 'clamp(2.5rem, 6vw, 4rem)', height: 'clamp(2.5rem, 6vw, 4rem)' }}>
                        <Icon className={step.color} size={24} />
                      </div>
                    </div>
                  </div>
                  
                  <h4 className="fw-bold text-dark mb-2" style={{ fontSize: 'clamp(0.9rem, 3.5vw, 1.5rem)' }}>
                    {step.title}
                  </h4>
                  <p className="text-muted" style={{ fontSize: 'clamp(0.8rem, 2.5vw, 1rem)' }}>
                    {step.description}
                  </p>
                </div>
              </div>
            );
          })}
        </div>

        {/* ✅ Pushed button a little lower using mt-4 */}
        <div className="d-flex flex-column flex-sm-row gap-2 justify-content-center mt-3 mt-md-4 mb-3 mb-md-5 px-2">
          <Link 
            to="/neet-college-predictor"
            className="btn btn-gradient btn-lg d-flex align-items-center justify-content-center gap-2 w-100 w-sm-auto"
            style={{ minHeight: '48px' }}
          >
            <Target size={20} />
            <span>Get NEET Predictions</span>
          </Link>
          <Link 
            to="/josaa-personalized-list"
            className="btn btn-outline-primary btn-lg d-flex align-items-center justify-content-center gap-2 w-100 w-sm-auto"
            style={{ minHeight: '48px' }}
          >
            <Target size={20} />
            <span>Get JEE Predictions</span>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
